import { buildEnum } from '@witmetrics/utils/objects';
import type { UnisonProjectTypeId } from '@witmetrics/utils';
import { UNISON_PROJECT_TYPE_ID } from '@witmetrics/utils/constants';

const {
  ALIGNERS,
  RETAINERS,
  NIGHTGUARD,
  BLEACHING_TRAY,
  VENEERS,
  ORTHO_MODELS,
  OTHER,
} = UNISON_PROJECT_TYPE_ID;

export const RELU_UPPER_ARCH = 'RELU_UPPER_ARCH';
export const RELU_LOWER_ARCH = 'RELU_LOWER_ARCH';

export const WIZARD_STEPS = buildEnum(
  'SELECT_PATIENT',
  'SELECT_FILES',
  'CASE_SETTINGS',
  'REVIEW'
);

export const CREATION_STEP = buildEnum(
  'CREATE_PROJECT',
  'UPLOAD_FILES',
  'SAVE_PENDING_ITEMS',
  'INITIALIZE_SERVICE'
);

export const CREATION_STEP_STATUS = buildEnum(
  'PENDING',
  'IN_PROGRESS',
  'DONE',
  'FAILED'
);

export const DIALOG_TITLE: Record<UnisonProjectTypeId, string> = {
  [ALIGNERS]: 'Aligner',
  [RETAINERS]: 'Retainer',
  [NIGHTGUARD]: 'Nightguard',
  [BLEACHING_TRAY]: 'Bleaching Tray',
  [VENEERS]: 'Veneers',
  [ORTHO_MODELS]: 'Orthodontic Models',
  [OTHER]: 'Custom',
} as const;
